import { render, staticRenderFns } from "./Etapa2.vue?vue&type=template&id=461fe264&scoped=true&"
import script from "./etapa2.ts?vue&type=script&lang=ts&"
export * from "./etapa2.ts?vue&type=script&lang=ts&"
import style0 from "./Etapa2.vue?vue&type=style&index=0&id=461fe264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461fe264",
  null
  
)

export default component.exports